import {
  Modal,
  Box,
  Typography,
  Slider,
  Switch,
  Select,
  MenuItem,
  FormControlLabel,
  Button
} from "@mui/material";

const positions = [
  'bottom-right',
  'bottom-left',
  'top-right',
  'top-left',
  'center'
];

const ChartSettingsModal = ({
  open,
  onClose,
  settings,
  onUpdate
}) => {
  const { enablePoints, pointSize, lineWidth, enableArea, onExport, enableZoom, legendPosition, showLegend, threshold }
    = settings;

  const handleChange = (key, value) => {
    onUpdate({ [key]: value });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Box sx={{
        background: 'white',
        p: 4,
        borderRadius: 2,
        width: '90%',
        maxWidth: 500,
        maxHeight: '90vh',
        overflow: 'auto',
        position: 'relative'
      }}>
        <Typography variant="h6" gutterBottom>Настройки графика</Typography>
        
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
          <div>
            <Typography variant="body2">Размер точек</Typography>
            <Slider
              value={pointSize}
              onChange={(_, value) => handleChange('pointSize', value)}
              min={0}
              max={20}
              valueLabelDisplay="auto"
            />
          </div>
          <div>
            <Typography variant="body2">Толщина линии</Typography>
            <Slider
              value={lineWidth}
              onChange={(_, value) => handleChange('lineWidth', value)}
              min={1}
              max={10}
              valueLabelDisplay="auto"
            />
          </div>
          <div>
            <Typography variant="body2">Порог (значение)</Typography>
            <Slider
              value={threshold && threshold.value !== undefined ? threshold.value : 80}
              onChange={(_, value) => handleChange('threshold', { 
                value: value,
                label: threshold?.label || 'Предел',
                color: threshold?.color || '#ff0000'
              })}
              min={0}
              max={100}
              valueLabelDisplay="auto"
            />
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
          <FormControlLabel
            control={<Switch checked={enablePoints} onChange={(_, checked) => handleChange('enablePoints', checked)} />}
            label="Показывать точки"
          />
          <FormControlLabel
            control={<Switch checked={enableArea} onChange={(_, checked) => handleChange('enableArea', checked)} />}
            label="Заливка под линией"
          />
          <FormControlLabel
            control={<Switch checked={onExport} onChange={(_, checked) => handleChange('onExport', checked)} />}
            label="Кнопка экспорта"
          />
          <FormControlLabel
            control={<Switch checked={enableZoom} onChange={(_, checked) => handleChange('enableZoom', checked)} />}
            label="Режим зума"
          />
          <FormControlLabel
            control={<Switch checked={showLegend !== undefined ? showLegend : true} onChange={(_, checked) => handleChange('showLegend', checked)} />}
            label="Показывать легенду"
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '16px', marginBottom: '16px' }}>
          <div>
            <Typography variant="body2">Позиция легенды</Typography>
            <Select
              value={legendPosition}
              onChange={(e) => handleChange('legendPosition', e.target.value)}
              size="small"
              fullWidth
            >
              {positions.map((pos) => (
                <MenuItem key={pos} value={pos}>{pos}</MenuItem>
              ))}
            </Select>
          </div>
        </div>

        <Button variant="contained" onClick={onClose}>
          Закрыть
        </Button>
      </Box>
    </Modal>
  );
};

export default ChartSettingsModal;